import { ControlValueConverter } from '@farris/devkit';

class FilterConditionsConverter implements ControlValueConverter {

  constructor() {
  }

  convertFrom(conditionsString: string): any[] {
    if (!conditionsString) {
      return [];
    }
    return JSON.parse(conditionsString);
  }

  convertTo(conditions: any[]): string {
    return JSON.stringify(conditions);
  }
}

export { FilterConditionsConverter };
